export default __webpack_public_path__ + "static/media/flexline_hd_logo.31ad7f99.png";